module.exports = __webpack_public_path__ + "static/anna_bil-4a81cbb3ca36712c7a6af543b9da5bd9.png";